var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.pager && _vm.pager.totalPages > 1)?_c('div',{staticClass:"results-info-wrapper"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-5"},[_c('div',{staticClass:"dataTables_info",attrs:{"id":"datatable-ecommerce-list_info","role":"status","aria-live":"polite"}},[_vm._v(" Showing "+_vm._s(_vm.fromResults)+" to "+_vm._s(_vm.toResults)+" of "+_vm._s(_vm.pager.totalItems)+" entries ")])]),_c('div',{staticClass:"col-7 mb-3 mb-lg-0"},[_c('nav',[_c('ul',{staticClass:"pagination pagination-modern pagination-modern-spacing justify-content-end mb-0"},[_c('li',{staticClass:"page-item",class:{ disabled: _vm.prevDisabled }},[_c('router-link',{staticClass:"page-link prev",attrs:{"to":{
                  query: {
                    page: 1,
                    search: _vm.$route.query.search,
                    ..._vm.paginationProps,
                  },
                }}},[_c('span',[_c('i',{staticClass:"fas fa-angle-double-left"})])])],1),_c('li',{staticClass:"page-item",class:{ disabled: _vm.prevDisabled }},[_c('router-link',{staticClass:"page-link prev",attrs:{"to":{
                  query: {
                    page: +_vm.currentRoute.query.page - 1,
                    search: _vm.$route.query.search,
                    ..._vm.paginationProps,
                  },
                }}},[_c('span',[_c('i',{staticClass:"fas fa-chevron-left"})])])],1),_vm._l((_vm.pages),function(index){return _c('li',{key:index,staticClass:"page-item",class:{
                active:
                  index == _vm.currentRoute.query.page ||
                  (index === 1 && !_vm.currentRoute.query.page),
              }},[_c('router-link',{staticClass:"page-link",attrs:{"exact":"","to":{
                  query: {
                    page: index,
                    search: _vm.$route.query.search,
                    ..._vm.paginationProps,
                  },
                }}},[_vm._v(" "+_vm._s(index)+" ")])],1)}),_c('li',{staticClass:"page-item",class:{ disabled: _vm.nextDisabled }},[_c('router-link',{staticClass:"page-link next",attrs:{"to":{
                  query: {
                    page: parseInt(_vm.currentRoute.query.page || 1, 10) + 1,
                    search: _vm.$route.query.search,
                    ..._vm.paginationProps,
                  },
                }}},[_c('span',[_c('i',{staticClass:"fas fa-chevron-right"})])])],1),_c('li',{staticClass:"page-item",class:{ disabled: _vm.nextDisabled }},[_c('router-link',{staticClass:"page-link next",attrs:{"to":{
                  query: {
                    page: _vm.pager.totalPages,
                    search: _vm.$route.query.search,
                    ..._vm.paginationProps,
                  },
                }}},[_c('span',[_c('i',{staticClass:"fas fa-angle-double-right"})])])],1)],2)])])])]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }